import { FormGroup } from '@angular/forms';
import {
    CompleteSortieCommand,
    DisplayableMissionDto
} from '@flyfreely-portal-ui/flyfreely';
import { Observable } from 'rxjs';
import { MissionRecordFormModel } from '../../mission-record-edit/mission-record.service';
import {
    DisplayableResource,
    MissionCompletionFormModel
} from '../mission-completion.service';

/**
 * This defines the interface that is used to provide central functions from the mission completion services
 */
export abstract class MissionCompletionOrRecordService {
    abstract availablePersonnel$: Observable<DisplayableResource[]>;
    abstract working$: Observable<boolean>;
    abstract savedMission$: Observable<DisplayableMissionDto>;
    abstract form: FormGroup<
        MissionCompletionFormModel | MissionRecordFormModel
    >;
    abstract updateMissionFromSortieCommand(
        sortieCommand: CompleteSortieCommand[],
        mission: DisplayableMissionDto
    ): Observable<DisplayableMissionDto>;
}
